import React from 'react';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { Card } from '../Card';

const AnotherProviderViewState = () => {
  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.COMPLETE_MY_VISIT_SUMMARY_MODAL,
  });

  return (
    <Card
      title={locale?.summaryDetails}
      titleClassName="flex text-h4 text-btn-black font-semibold"
      showSeparator
      defaultExpanded
      subtitleClassName="!text-base font-medium max-desktop:mt-2.5"
    >
      <div className="w-full h-full text-center py-48 px-32">
        <div className="text-lg font-semibold mb-1">
          {'Appointment summary is pending.'}
        </div>
        <div className="font-medium text-med-gray-3">
          {'It will be visible after the provider submits it'}
        </div>
      </div>
    </Card>
  );
};

export default AnotherProviderViewState;
